import request from '@/router/axios';
let urlPrefix = '/api/shenbao/shenbaoexplog'
// /shenbaoexplog/{shenbaoId}/shenbao/statistics

/**
 * 获取对象
 * @param {ID} id
 */
export const getStaticInfo = shenbaoId => {
    return request(`${urlPrefix}/${shenbaoId}/shenbao/statistics`,)
}
